import { SystemStyleObjectRecord } from '@chakra-ui/react';
import { CDN_IMAGES_URL } from '@core/config';
import { colors } from '@waitroom/config';

const overlaySx = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 2,
};

export default {
  overlay: overlaySx,
  'overlay-tr': {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 2,
  },
  'label-subtext': {
    fontSize: '2xs',
    color: 'gray.500',
    fontWeight: 'normal',
  },
  'tag-simple': {
    boxShadow: `inset 0 0 0px 1px ${colors.gray[200]}`,
    py: '.4em',
    color: 'black',
  },
  'bg-square': {
    _before: {
      content: '" "',
      position: 'absolute',
      w: '105%',
      h: '105%',
      left: '-2.5%',
      top: '-2.5%',
      bg: 'orange.200',
      transform: 'rotate(-15deg)',
      borderRadius: 'inherit',
    },
  },
  'bg-blob': {
    position: 'relative',
    _before: {
      content: '" "',
      position: 'absolute',
      w: '120%',
      h: '120%',
      left: '-10%',
      top: '-10%',
      bgImg: `url(${CDN_IMAGES_URL}/blob.svg)`,
      bgSize: 'cover',
      bgRepeat: 'no-repeat',
      zIndex: '-1',
    },
  },
  'button-badge': {
    position: 'absolute',
    top: 0,
    right: '-.25rem',
    width: '1.5em',
    height: '1.5em',
    fontSize: '.5em',
    lineHeight: '1.5',
    zIndex: 2,
  },
  'bg-image': {
    bgSize: 'cover',
    bgPosition: 'center',
    bgRepeat: 'no-repeat',
  },
  'hover:o': {
    opacity: 0.75,
    transition: 'opacity .1s ease-in',
    _hover: {
      opacity: 1,
    },
  },
  compact: {
    lineHeight: 'shorter',
    letterSpacing: 'tight',
  },
  'skeleton-subtle': {
    opacity: 0.18,
  },
} satisfies SystemStyleObjectRecord;
